import { FC, ReactNode } from 'react';
import { Typography } from '@altermaind/web/ui';

/**
 * Inline wrapper used by `EmbeddedStyle` to render text between `<i>` / `</i>`
 * placeholders in italic. Renders as an inline `Typography` so it can be safely
 * nested inside another Typography without breaking the line flow.
 *
 * @param {ReactNode} children - Content to be rendered in italic.
 *
 * @returns {JSX.Element} The italicized inline content.
 */
export const ItalicLabel: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Typography as='span' fontStyle='italic'>
      {children}
    </Typography>
  );
};
